import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import {
  MobileDateTimeRangePicker,
  MobileDateTimeRangePickerProps,
} from "@mui/x-date-pickers-pro/MobileDateTimeRangePicker";
import { FormControl, FormLabel } from "@mui/material";
import { renderTimeViewClock } from "@mui/x-date-pickers";
import { Dayjs } from "dayjs";

function DateTimeRangeInput({
  label,
  labelStart,
  labelEnd,
  ...rest
}: MobileDateTimeRangePickerProps<Dayjs> & {
  label?: string;
  labelStart?: string;
  labelEnd?: string;
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormControl sx={{ gap: "var(--gap-small)" }}>
        <FormLabel>{label}</FormLabel>
        <MobileDateTimeRangePicker
          viewRenderers={{
            hours: renderTimeViewClock,
            minutes: renderTimeViewClock,
            seconds: renderTimeViewClock,
          }}
          localeText={{
            start: labelStart ?? "Început",
            end: labelEnd ?? "Final",
          }}
          format="DD/MM/YYYY HH:mm"
          {...rest}
        />
      </FormControl>
    </LocalizationProvider>
  );
}

export default DateTimeRangeInput;
